import cloneDeep from 'lodash/cloneDeep';

const indexDBReplica = {};

const globalKeyPathObj = {};

function createIndex(parentObj, index1, index2) {
  const currentObj = (parentObj[index1] = null);
  globalKeyPathObj[index1] = index2;
  return cloneDeep(currentObj);
}

function createObjectStore(parentObj, store, keyPathObj) {
  const currentObj = (parentObj[store] = {});
  const returnObj = {
    createIndex: (index1, index2, obj) => createIndex(currentObj, index1, index2, obj)
  };
  globalKeyPathObj[store] = keyPathObj.keyPath;
  return returnObj;
}

function getAllById(dbName, store, i, id) {
  const currentObj = indexDBReplica[dbName][store];
  const allItemsValues = Object.values(currentObj);
  const returnArr = allItemsValues.filter(item => (item && item[globalKeyPathObj[i]]) === id);
  return cloneDeep(returnArr);
}

function index(dbName, store, i) {
  const returnObj = {
    getAll: id => getAllById(dbName, store, i, id)
  };
  return returnObj;
}

function put(dbName, store, obj) {
  const key = obj[globalKeyPathObj[store]];
  indexDBReplica[dbName][store][key] = cloneDeep(obj);
}

function getAll(dbName, store) {
  const currentObj = indexDBReplica[dbName][store];
  const allItemsKeys = Object.keys(currentObj);
  const returnArr = [];
  allItemsKeys.forEach((item) => {
    returnArr.push(currentObj[item]);
  });
  return cloneDeep(returnArr);
}

function getById(dbName, store, id) {
  const currentObj = indexDBReplica[dbName][store];
  const returnObj = currentObj[id];
  return cloneDeep(returnObj);
}

function deleteIndividualStore(dbName, store, itemId) {
  delete indexDBReplica[dbName][store][itemId];
}

function deleteFromDB(dbName, store, id) {
  if (Array.isArray(id)) {
    id.forEach((itemId) => {
      deleteIndividualStore(dbName, store, itemId);
    });
  } else {
    deleteIndividualStore(dbName, store, id);
  }
}

function clear(dbName, store) {
  if (indexDBReplica[dbName]) {
    indexDBReplica[dbName][store] = {};
  }
}

function objectStore(dbName, store) {
  const returnObj = {
    index: i => index(dbName, store, i),
    put: obj => put(dbName, store, obj),
    getAll: () => getAll(dbName, store),
    get: id => getById(dbName, store, id),
    delete: id => deleteFromDB(dbName, store, id),
    clear: () => clear(dbName, store)
  };
  return returnObj;
}

function transaction(dbName) {
  const returnObj = {
    objectStore: store => objectStore(dbName, store)
  };
  return returnObj;
}

function objectStoreNames(dbName) {
  const storeNameArray = Object.keys(indexDBReplica[dbName]);
  storeNameArray.contains = storeNameArray.includes;
  return storeNameArray;
}

function open(dbName, dbVersion, cb) {
  const currentObj = (indexDBReplica[dbName] = {});
  const returnObj = {
    result: {
      createObjectStore: (store, keyPathObj) => createObjectStore(currentObj, store, keyPathObj),
      transaction: (store, operation) => transaction(dbName, store, operation)
    },
    oldVersion: 0,
    get objectStoreNames() {
      return objectStoreNames(dbName);
    },
    createObjectStore: (store, keyPathObj) => createObjectStore(currentObj, store, keyPathObj),
    transaction: (store, operation) => transaction(dbName, store, operation)
  };
  cb && cb(returnObj);
  return new Promise((resolve) => {
    resolve(returnObj);
  });
}

const iDB = function () {};
iDB.open = open;

window.iDB = iDB;
window.indexDBReplica = indexDBReplica;
window.globalKeyPathObj = globalKeyPathObj;

export default iDB;
